// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"93":"c1de9931","154":"4c36d361","194":"755d8e66","254":"8f89e668"}[chunkId] + ".chunk.css";
};